import { FormikProps } from 'formik';
import React, { useEffect } from 'react';
import MiniAppEvents from 'src/helpers/miniapp-events';

interface IMiniAppFocusWrapperProps {
  innerComponent: React.FC;
  onFocus?: (e: unknown) => void;
  form?: FormikProps<unknown>;
}

export const MiniAppFocusWrapper: React.FC<IMiniAppFocusWrapperProps> = ({
  innerComponent,
  ...props
}) => {
  const inMiniProgram = MiniAppEvents.isInMiniApp();
  const Component = innerComponent;
  let timeout;

  useEffect(() => {
    return () => clearTimeout(timeout);
  });
  const onFocusOverride = (e) => {
    if (props.onFocus) {
      props.onFocus(e);
    }
    if (inMiniProgram) {
      MiniAppEvents.toggleKeyboardOpenPadding(true, 'OnboardingContainer');
      const target = e.target;
      const rect = target.getBoundingClientRect();

      const windowHeight = window.innerHeight;
      const bottom = rect.top + rect.height;
      const forbiddenZone = windowHeight * 0.5;
      if (bottom >= forbiddenZone) {
        clearTimeout(timeout);
        const scrollBy = Math.min(bottom + 40 - forbiddenZone, rect.top - 5);

        const parentModal = target.closest('.Modal');
        let scrollableElement = window;
        if (parentModal) {
          scrollableElement = parentModal;
        }

        timeout = setTimeout(() => {
          scrollableElement.scrollBy({
            top: scrollBy,
            left: 0,
          });
        }, 100);
      }
    }
  };

  const onBlurOverride = (e) => {
    if (props?.form?.handleBlur && !e.dontCallFormikHandleBlur) {
      props.form.handleBlur(e);
    }

    if (inMiniProgram) {
      MiniAppEvents.toggleKeyboardOpenPadding(false, 'OnboardingContainer');
    }
  };

  const newProps = {
    ...props,
    onFocus: onFocusOverride,
    onBlur: onBlurOverride,
  };

  return <Component {...newProps}></Component>;
};
